import {Button, Flex, Text, VStack} from "@chakra-ui/react";

const SummaryTickets = ({attendees, ticketTypes, dwn, order, t}) => {
    const label = t('ticket.standard');

    const getTicketName = (ticketId) => {
        return ticketTypes?.find(t => (t.id) === (ticketId))?.name || label;
    };

    return <VStack spacing={4} align="stretch">
        {order?.tickets?.map((ticket, i) => (
            <Flex key={i} p={4} borderWidth={0} bgColor={'#F3F3F3'} gap="32px" flexDirection={"row"}
                  fontFamily="Nunito" fontSize="18px" fontWeight="500" alignItems={"center"}>
                <Text fontFamily="Nunito" fontSize="20px" fontWeight="700" color={'#089A7A'}>
                    #{i+1}
                </Text>
                <Flex w={"full"} gap="32px">
                    <Flex flexDirection={"column"} flex="1">
                        <Text>
                            {t('order.summary.ticket.type')}
                        </Text>
                        <Text fontWeight="700">
                            {getTicketName(ticket.ticketId)}
                        </Text>
                    </Flex>
                    <Flex flexDirection={"column"} flex="1">
                        <Text>
                            {t('order.summary.ticket.name')}
                        </Text>
                        <Text fontWeight="700">
                            {ticket.name} {ticket.surName}
                        </Text>
                    </Flex>
                </Flex>
                {dwn && <Flex w={"full"} justifyContent={"flex-end"}>
                    <Button
                    borderRadius={'4px'}
                    color={'#FFFFFF'}
                    bgColor={'#089A7A'}
                    py={'25px'}
                    px={'45px'}
                    onClick={() => dwn(ticket.ticketId, ticket.downloadToken)}>
                        {t('order.summary.ticket.download')}
                </Button>
                </Flex>}
            </Flex>
        ))}
    </VStack>;
}
export default SummaryTickets;
